export function openCrispChat(): void {
    window.$crisp?.push(['do', 'chat:show']);
    window.$crisp?.push(['do', 'chat:open']);
}
